export default "__VITE_ASSET__DzA60nyx__"